module.exports = __webpack_public_path__ + "img/special_blue.ddda1215.png";